import React from 'react'
import {useIntl} from 'react-intl'
import activeFolderIcon from '../../../../../_metronic/assets/images/svg/data-room/blue-folder-icon.svg'
import {Link, useNavigate} from 'react-router-dom'
import {getFileType} from '../../../../core/_util'
import Skeleton from 'react-loading-skeleton'
import {getLocation} from '../../../onboarding/core/_requests'
import {useAuth} from '../../../auth'
import {createAccess, createActivityLog} from '../../core/_requests'
import {toast} from 'react-toastify'
import NoDataPage from '../../../widgets/components/NoDataPage'

const QuickViewRecentUploads = ({overviewData, loading}: {overviewData: any; loading: boolean}) => {
  const {formatMessage} = useIntl()
  const {companyId, currentUser} = useAuth()
  const navigate = useNavigate()

  const getDeviceType = () => {
    const ua = navigator.userAgent

    if (
      /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera Mobi|Blazer|Dolfin|Dolphin|Skyfire|Zune/.test(
        ua
      )
    ) {
      return 'MOBILE'
    }
    return 'WEB'
  }

  const getOS = () => {
    const ua = navigator.userAgent
    if (/iPhone|iPad|iPod|Macintosh/.test(ua)) return 'APPLE'
    if (/Win/.test(ua)) return 'WINDOWS'
    if (/android/i.test(ua)) return 'ANDROID'
    return 'Unknown'
  }

  const createActivity = async (recordId: any) => {
    const os = getOS()
    const deviceTypeView = getDeviceType()
    const locationApiData = await getLocation()
    const city = locationApiData?.data.country_name

    const ipAddress = locationApiData?.data?.ip
    try {
      if (deviceTypeView && os && city && recordId && companyId) {
        const {
          data: {success, errors},
        } = await createActivityLog(
          companyId,
          recordId,
          os,
          deviceTypeView,
          city,
          ipAddress,
          'VIEWED'
        )
        if (!success) {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  const createAccessLog = async (recordId: any) => {
    const os = getOS()
    const deviceTypeView = getDeviceType()
    const locationApiData = await getLocation()
    const city = locationApiData?.data.country_name
    const ipAddress = locationApiData?.data?.ip

    try {
      if (deviceTypeView && os && city && recordId && companyId && currentUser?.userId) {
        const {
          data: {success, errors},
        } = await createAccess(
          recordId,
          os,
          deviceTypeView,
          city,
          ipAddress,
          'CREATE',
          companyId,
          currentUser?.userId
        )
        if (!success) {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <div className='bg-white rounded p-6 my-8'>
      <div className='d-flex flex-md-row flex-column justify-content-md-between align-items-start align-items-md-center gap-2 mb-2'>
        <h1 className='font-size-16 mb-0'>{formatMessage({id: 'Quick View Recent Uploads'})}</h1>
        <Link
          to='/rk/overview/recent-uploads'
          className='d-none d-md-block font-size-13 text-primary cursor-pointer'
        >
          {formatMessage({id: 'View All'})}
        </Link>
      </div>
      {loading ? (
        <>
          <div className='d-md-none d-block'>
            <Skeleton
              className='w-100'
              style={{width: '25% !important'}}
              height={20}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
          </div>
          <div className='d-none d-md-block'>
            <Skeleton
              className='w-100'
              style={{width: '25% !important'}}
              height={20}
              baseColor='var(--kt-skeleton-bg-color)'
              highlightColor='var(--kt-skeleton-highlight-bg-color)'
            />
          </div>
        </>
      ) : (
        <div className='d-flex justify-content-between'>
          <p className='text-muted font-size-13 mb-0'>
            {formatMessage({
              id: `${overviewData?.recordKeeperFilesOneWeekAgo} Files Added Recently`,
            })}
          </p>
          <Link
            to='/rk/overview/recent-uploads'
            className='d-md-none d-block font-size-13 text-primary cursor-pointer'
          >
            {formatMessage({id: 'View All'})}
          </Link>
        </div>
      )}

      {loading ? (
        [...Array(10)].map((_, index) => (
          <div key={index} className="my-2">
            <Skeleton
              containerClassName="w-100"
              width="100%"
              height={50}
              baseColor="var(--kt-skeleton-bg-color)"
              highlightColor="var(--kt-skeleton-highlight-bg-color)"
            />
          </div>
        ))
      ) : overviewData?.recordKeeperFilesForTimeAgo &&
        overviewData?.recordKeeperFilesForTimeAgo.length > 0 ? (
        overviewData.recordKeeperFilesForTimeAgo.slice(0, 10).map((upload: any, index: any) => (
          <div key={index} className="d-md-flex justify-content-between align-items-center my-4">
             <>
                <div className='d-md-flex gap-4 align-items-center w-md-500px w-auto'>
                  <img
                    src={getFileType(upload?.recordKeeperFileVersion?.fileName)}
                    alt={upload?.recordKeeperFileVersion?.name}
                    width={24}
                    height={24}
                    className='mb-md-0 mb-2'
                  />
                  <div>
                    <p className='font-size-13 m-0'>
                      {upload.documentName.split('.')[0].length > 30
                        ? `${upload.documentName.split('.')[0].substring(0, 30)}...`
                        : upload.documentName.split('.')[0]}
                    </p>
                    {upload.recordKeeperFileVersion.isFileProcessed ? (
                      <p className='font-size-10 text-muted m-0'>
                        <span className='d-flex'>
                          <img
                            src={activeFolderIcon}
                            alt='folder icon'
                            height={14}
                            width={14}
                            className='me-2'
                          />

                          <p className='w-100 font-size-10 text-wrap mb-4 mb-md-0'>
                            {upload?.folderStructure?.structureClassificationLevelOne?.name} {'>'}{' '}
                            {upload?.folderStructure?.structureClassificationLevelTwo?.name} {'>'}{' '}
                            {upload?.folderStructure?.structureClassificationLevelThree?.name}
                          
                          </p>
                        </span>
                      </p>
                    ) : (
                      <p className='font-size-10 text-muted mb-4 mb-md-0'>
                        {formatMessage({
                          id: 'Please wait for 1-2 minutes while the file is processed with AI. After that you can check the "Records & Files" section or "Overview" section',
                        })}
                      </p>
                    )}
                  </div>
                </div>

                <div className=' d-flex flex-md-column flex-row align-items-center gap-2 gap-md-0 mb-md-0 mb-4'>
                  <p className='font-size-13 m-0'>{formatMessage({id: upload.timeAgo})}</p>
                  <p className='font-size-10 text-muted m-0'>{formatMessage({id: 'Uploaded'})}</p>
                </div>

                {upload.recordKeeperFileVersion.isFileProcessed ? (
                  <div>
                    <button
                      className='btn btn-light w-100 w-md-auto'
                      style={{minWidth: '150px'}}
                      onClick={() => {
                        navigate(`/rk/records-and-files/files-details/${upload?.recordId}`)
                        createActivity(upload?.recordId)
                        createAccessLog(upload?.recordId)
                      }}
                    >
                      {formatMessage({id: 'View'})}
                    </button>
                  </div>
                ) : (
                  <div>
                    <button
                      className='btn btn-light w-100 w-md-auto'
                      style={{minWidth: '150px'}}
                      disabled={true}
                    >
                      {formatMessage({id: 'Processing'})}
                    </button>
                  </div>
                )}
              </>
          </div>
        ))
      ) : (
        <div className='no-data-found text-center'>
          <NoDataPage />
        </div>
      )}
    </div>
  )
}

export default QuickViewRecentUploads
